var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.open && _vm.routeAllowsFloat
    ? _c("div", { staticClass: "leo-admin-float-root" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.minimized,
                expression: "minimized"
              }
            ],
            staticClass: "leo-admin-float-pill",
            style: _vm.pillStyle,
            attrs: { type: "button" },
            on: { click: _vm.expand }
          },
          [_vm._v("\n    Leo\n  ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.minimized,
                expression: "!minimized"
              }
            ],
            ref: "panel",
            staticClass: "leo-admin-float-panel",
            style: _vm.panelStyle
          },
          [
            _c(
              "header",
              {
                staticClass: "leo-admin-float-head",
                on: {
                  mousedown: function($event) {
                    $event.preventDefault()
                    return _vm.onDragStart.apply(null, arguments)
                  }
                }
              },
              [
                _c("span", { staticClass: "leo-admin-float-title" }, [
                  _vm._v(_vm._s(_vm.$t("route.leoFloatDockTitle")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "leo-admin-float-actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "leo-admin-float-iconbtn",
                      attrs: {
                        type: "button",
                        title: _vm.$t("route.leoFloatDockMinimize"),
                        "aria-label": "minimize"
                      },
                      on: { click: _vm.minimize }
                    },
                    [_vm._v("\n          −\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "leo-admin-float-iconbtn leo-admin-float-iconbtn--close",
                      attrs: {
                        type: "button",
                        title: _vm.$t("route.leoFloatDockClose"),
                        "aria-label": "close"
                      },
                      on: { click: _vm.close }
                    },
                    [_vm._v("\n          ×\n        ")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("iframe", {
              staticClass: "leo-admin-float-iframe",
              attrs: { src: _vm.frameSrc, title: "Leo chat" }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "leo-admin-float-resize",
              attrs: {
                title: _vm.$t("route.leoFloatDockResizeHint"),
                "aria-hidden": "true"
              },
              on: {
                mousedown: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.onResizeStart.apply(null, arguments)
                }
              }
            })
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2136f830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2136f830","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeoAdmin/LeoAdminFloatDock.vue
// module id = null
// module chunks = 